import { action } from 'satcheljs';
export var manageSecurity = action('manageSecurity');
//# sourceMappingURL=manageSecurity.js.map